import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import queryString from "query-string";
import {Link} from "react-router-dom";
import ApiService from "../../Services/ApiService.js";
import LoadingScreen from "../misc/loading.js";
import ErrorScreen from "../misc/error.js";
import CloneModal from "./cloneModal";

class Campaignlist extends React.Component {

  state = {
    loading: true,
    data: null,
    error: false,
    client: null,
    selected_campaign: '',
  };

  componentDidMount() {
    let params = queryString.parse(this.props.location.search);
    this.clientId = params.client_id;
    this.clientName = params.client_name;

    this.fetchCampaigns();
  }
  
  handleEdit = (clientId, campaignId, clientName) => {
    this.props.history.push("/campaignGroup?client_id=" + clientId + "&campaign_id=" + campaignId + "&client_name=" + clientName);
  };

  handleDelete = (campaignId) => {
    if (window.confirm('Are you sure you want to delete this campaign?')) {
      ApiService.post('/api/campaigns/delete', {'campaign_id': campaignId})
          .then(response => {
              this.fetchCampaigns();
          });
    }
  }

  showModal = (campaignId) => {
    let modal = document.getElementById("clone-modal");
    this.setState({...this.state, selected_campaign: campaignId}, () => {
      modal.style.display = "block";
    });
  };

  hideModal = () => {
    let modal = document.getElementById("clone-modal");
    modal.style.display = "none";
    this.fetchCampaigns();
  };

  fetchCampaigns = () => {
    const url = "/api/campaigns?client_id=" + this.clientId;
    ApiService.get(url)
        .then(response => {

          if (response.data.Success) {
            this.setState({
              data: response.data.Campaigns.reverse(),
              loading: false,
              error: false,
              client: response.data.Campaigns.length > 0 ? response.data.Campaigns[0].client_name : ''
            });
          } else {
            this.props.history.push("/clients");
          }
        });
  }
  
  render() {
    const { loading, error, data, client } = this.state;
    if (loading) {
      return <LoadingScreen/>;
    }
    if (error) {
      return <ErrorScreen/>;
    }
    const columns = [
      {
        Header: "Campaign",
        accessor: "campaign_name"
      },
      {
        Header: "Status",
        accessor: "status"
      },
      {
        Header: "Start Date",
        accessor: "start_date"
      },
      {
        Header: "End Date",
        accessor: "end_date"
      },
      {
        Header: "Action",
        Cell: (data) => {
          if(data && data.row._original.campaign_id) {
            let campaignId = data.row._original.campaign_id
            return(
                <div>
                  <button title="Edit Campaign" className="table-btn edit-btn" onClick={() => this.handleEdit(this.clientId, campaignId, this.clientName) }> <i className="fa fa-edit"></i> </button>
                  <button title="Clone Campaign"  className="table-btn edit-btn" onClick={() => this.showModal(campaignId) }> <i className="fa fa-clone"></i> </button>
                  <button title="Delete Campaign"  className="table-btn" onClick={() => this.handleDelete(campaignId) }> <i className="fa fa-trash-o"></i> </button>
                </div>

          )
          } else {
            return("");
          }
        }
        
      }
    ];

    return (

    <div className="page-main">
      <div>
        <button className="add-btn" onClick = {() => { this.props.history.push("/campaignGroup/addCampaign?client_id="+this.clientId)}} >
          Add Campaign
        </button>
      </div>

      <div className="page-content">
        <div className="table-style">
          <ReactTable
              data={data}
              columns={columns}
              showPagination={true}
              minRows={0}
              defaultPageSize={50}
          />
        </div>
      </div>
        <CloneModal campaignID={this.state.selected_campaign} onClose={this.hideModal}/>
    </div>

    ); 
      
  }
}
export default Campaignlist;
